
<div class="inner-adjust">
    <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">{{personnage?.nom}}</h1>
      
      <a routerLink="/characterSheets/{{personnage?.id}}/Print" class="inverted"><i class="fas fa-user"></i>Imprimer ma fiche de personnage</a>
    </div>
    <!-- Show user data when logged in -->
    <ul id="personnageTab" class="nav nav-tabs mb-2" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Sommaire</button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="background-tab" data-bs-toggle="tab" data-bs-target="#background" type="button" role="tab" aria-controls="background" aria-selected="false">Historique</button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="competences-tab" data-bs-toggle="tab" data-bs-target="#competences" type="button" role="tab" aria-controls="competences" aria-selected="false">Compétences</button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="hasBoucherie()">
        <button class="nav-link" id="sort-boucherie-tab" data-bs-toggle="tab" data-bs-target="#sortBoucherie" type="button" role="tab" aria-controls="sortBoucherie" aria-selected="false">Boucherie</button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="hasSorcellerie()">
        <button class="nav-link" id="sort-sorcellerie-tab" data-bs-toggle="tab" data-bs-target="#sortSorcellerie" type="button" role="tab" aria-controls="sortSorcellerie" aria-selected="false">Sorcellerie</button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="hasPharmacologie()">
        <button class="nav-link" id="sort-pharmacologie-tab" data-bs-toggle="tab" data-bs-target="#sortPharmacologie" type="button" role="tab" aria-controls="sortPharmacologie" aria-selected="false">Pharmacologie</button>
      </li>
    </ul>
    <div *ngIf="personnage != null" class="tab-content" id="personnageTabContent">
      <div class="tab-pane fade" id="background" role="tabpanel" aria-labelledby="background-tab">
        <app-character-sheet-background [personnage]="personnage" (personnageChange)="updatePersonnage($event)"></app-character-sheet-background>
      </div>
      <div class="tab-pane fade" id="competences" role="tabpanel" aria-labelledby="competences-tab">
        <app-character-sheet-competences [personnage]="personnage" (personnageChange)="updatePersonnage($event)"></app-character-sheet-competences>
      </div>
      <div class="tab-pane fade" id="sortBoucherie" role="tabpanel" aria-labelledby="sort-boucherie-tab">
        <app-character-sheet-sorts [personnage]="personnage" [typeDeSort]="0" (personnageChange)="updatePersonnage($event)"></app-character-sheet-sorts>
      </div>
      <div class="tab-pane fade" id="sortSorcellerie" role="tabpanel" aria-labelledby="sort-sorcellerie-tab">
        <app-character-sheet-sorts [personnage]="personnage" [typeDeSort]="2" (personnageChange)="updatePersonnage($event)"></app-character-sheet-sorts>
      </div>
      <div class="tab-pane fade" id="sortPharmacologie" role="tabpanel" aria-labelledby="sort-pharmacologie-tab">
        <app-character-sheet-sorts [personnage]="personnage" [typeDeSort]="3" (personnageChange)="updatePersonnage($event)"></app-character-sheet-sorts>
      </div>
      <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
        <div class="row">
          <div class="col-md-12">
            <div class="media">
              <div class="media-body">        
                <form [formGroup]="characterSheetForm" (ngSubmit)="onSubmit()">
                  <div class="form-group">
                    <span class="label">Nom de personnage: </span>{{personnage?.nom}}
                  </div>             
                  <div class="form-group">
                    <div><span class="label">Légion: </span>{{getLegionName(personnage?.legion)}}</div>
                  </div>   
                  <div class="form-group">
                    <div><span class="label">Astre: </span>{{getAstreName(personnage?.astre1)}}</div>
                  </div>    
                  <div class="form-group" *ngIf="personnage?.astre2">
                    <div><span class="label">Second Astre: </span>{{getAstreName(personnage?.astre2)}}</div>
                  </div>   
                  <div class="form-group">
                    <div><span class="label">Nombre de GN participés: </span>{{personnage?.nombreGnParticipe}}</div>
                  </div>                   
                  <div class="form-group">
                    <div><span class="label">Crimsons disponibles: </span>{{personnage?.crimsonDisponible}}</div>
                  </div>         
                  <div class="form-group">
                    <div><span class="label">Case de compétences disponible: </span>{{personnage?.achatDisponible}}</div>
                  </div>       
                  <div class="form-group">
                    <div><span class="label">Points d'achat disponible: </span>{{personnage?.achatSortDisponible}}</div>
                  </div>        
                  <div class="form-group">
                    <span class="label">Notes publiques: </span>{{personnage?.notePublic}}
                  </div>
                  <div class="form-group">
                    <span class="label">Liste des avoirs: </span>{{personnage?.avoirs}}
                  </div>
                </form>    
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>